export const routes = [
  {
    path: '/auth/login',
    component: () => import(/* webpackChunkName: "auth" */ './components/Login'),
    name: 'auth.login'
  },
  {
    path: '/auth/lost-password',
    component: () => import(/* webpackChunkName: "auth" */ './components/LostPassword'),
    name: 'auth.lost.password'
  },
  {
    path: '/auth/recover-password/:token',
    component: () => import(/* webpackChunkName: "auth" */ './components/RecoverPassword'),
    props: true,
    name: 'auth.token'
  }
]
